import styles from "@/components/product-icon.module.css";
import { PremiumApp } from "@/types";
import clsx from "clsx";
import { JSX } from "react";

interface IconInfo {
	icon: string;
	iconFallback?: string;
}

interface ProductIconInfo {
	airportal: IconInfo;
	webHosting: IconInfo;
}

interface ProductIconProps {
	hasShadow?: boolean;
	product?: PremiumApp;
	shouldHideOnMobile?: boolean;
	size: number;
}

const PRODUCT_ICON = Object.freeze<ProductIconInfo>({
	airportal: {
		icon: "https://assets.retiehe.com/ap-apple-touch-icon-2.webp",
		iconFallback: "https://assets.retiehe.com/ap-apple-touch-icon-2.png",
	},
	webHosting: {
		icon: "https://assets.retiehe.com/host-icon-512-2.png",
	},
});

function ProductIcon({
	hasShadow,
	product,
	shouldHideOnMobile,
	size,
}: ProductIconProps): JSX.Element {
	if (!product) {
		return <></>;
	}

	const { icon, iconFallback } = PRODUCT_ICON[product];

	return iconFallback ? (
		<picture
			className={clsx(
				styles["product-icon"],
				hasShadow && styles["shadow"],
				shouldHideOnMobile && styles["hide-on-mobile"],
			)}
			style={{ height: size, width: size }}
		>
			<source
				srcSet={icon}
				type="image/webp"
			/>
			<img
				src={iconFallback}
				alt=""
				draggable="false"
			/>
		</picture>
	) : (
		<img
			className={clsx(
				styles["product-icon"],
				hasShadow && styles["shadow"],
				shouldHideOnMobile && styles["hide-on-mobile"],
			)}
			src={icon}
			style={{ height: size, width: size }}
			alt=""
			draggable="false"
		/>
	);
}

export default ProductIcon;
